module.exports = __webpack_public_path__ + "img/imagine_dragons-coffret.d028f693.jpg";